import slick from 'slick-carousel';

document.addEventListener('DOMContentLoaded', () => {
  const startHomeSlick = () => {
    const $carousel = $('.homeCarrousel');

    $carousel.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 3,
          }
        },
      ],
      arrows: true,
      swipe: true,
    });

    // For load delay:
    setTimeout(() => {
      $carousel.trigger('init');
      $carousel.css('opacity', '1');
    }, 100);
  }

  startHomeSlick();

});


